import React from "react"
import { Route, Switch, useRouteMatch } from "react-router"

import DrugFactDetails from "./components/drug-fact-details"
import DrugFactsDirectory from "./components/drug-facts-directory"

import { DrugTypeEnum, DosageTypeEnum } from "typings/types"

/*
  `contentfulPath` should match the ones in contentful
  They are hardcoded because we don't want to add `drugType`, `dosageType` data to contentful but we need a way to map products
  to their drug fact page paths. It was decided to hardcode copy-paste paths from contentful as opposed to adding new fields (`drugType`, `dosageType`) into contentful
*/
export const PRODUCT_DRUG_FACT_PATHS = [
  {
    contentfulPath: "/cambia",
    drugType: DrugTypeEnum.Diclofenac,
    dosageType: DosageTypeEnum.PowderMg
  },
  {
    contentfulPath: "/nurtec-odt",
    drugType: DrugTypeEnum.Rimegepant,
    dosageType: DosageTypeEnum.OdtMg
  },
  {
    contentfulPath: "/migraine-relief",
    drugType: DrugTypeEnum.MigraineRelief,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/ondansetron-odt",
    drugType: DrugTypeEnum.Ondansetron,
    dosageType: DosageTypeEnum.OdtMg
  },
  {
    contentfulPath: "/ondansetron",
    drugType: DrugTypeEnum.Ondansetron,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/nortriptyline",
    drugType: DrugTypeEnum.Nortriptyline,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/metoprolol",
    drugType: DrugTypeEnum.Metoprolol,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/zolmitriptan",
    drugType: DrugTypeEnum.Zolmitriptan,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/zomig-nasal-spray",
    drugType: DrugTypeEnum.Zolmitriptan,
    dosageType: DosageTypeEnum.SprayMg
  },
  {
    contentfulPath: "/naratriptan",
    drugType: DrugTypeEnum.Naratriptan,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/eletriptan",
    drugType: DrugTypeEnum.Eletriptan,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/amitriptyline",
    drugType: DrugTypeEnum.Amitriptyline,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/sumatriptan",
    drugType: DrugTypeEnum.Sumatriptan,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/propranolol",
    drugType: DrugTypeEnum.Propranolol,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/rizatriptan",
    drugType: DrugTypeEnum.Rizatriptan,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/eletriptan",
    drugType: DrugTypeEnum.Eletriptan,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/topiramate",
    drugType: DrugTypeEnum.Topiramate,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/rizatriptan-odt",
    drugType: DrugTypeEnum.Rizatriptan,
    dosageType: DosageTypeEnum.OdtMg
  },
  {
    contentfulPath: "/naproxen",
    drugType: DrugTypeEnum.Naproxen,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/metoclopramide",
    drugType: DrugTypeEnum.Metoclopramide,
    dosageType: DosageTypeEnum.PillMg
  },
  {
    contentfulPath: "/emgality-galcanezumab-gnlm",
    drugType: DrugTypeEnum.GalcanezumabGnlm,
    dosageType: DosageTypeEnum.InjectableMg
  }
]

const DrugFacts = () => {
  const match = useRouteMatch()

  return (
    <Switch>
      <Route exact path={match.url} component={DrugFactsDirectory} />
      <Route exact path={`${match.url}/:drugFactPath`} component={DrugFactDetails} />
    </Switch>
  )
}

export default DrugFacts
